
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/editorSearch/views/ErrorState/ErrorState.scss.css.virtualfile';
        module.exports = {"footer":"_footer_oe3rm_1","footerLink":"_footerLink_oe3rm_8"};